import React from 'react';
import { ButtonPrimary } from '@spotify-internal/encore-creator-web';
import { ErrorPage } from '../shared/components/ErrorPage';

export function AppError() {
  return (
    <>
      <ErrorPage
        action={
          <ButtonPrimary onClick={() => window.location.reload()}>
            Reload
          </ButtonPrimary>
        }
      />
    </>
  );
}
